import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage';
import ClientDetailPage from './pages/ClientDetailPage';
import ClientHistoryPage from './pages/ClientHistoryPage';
import FollowUpsPage from './pages/FollowUpsPage';
import PotentialCustomersPage from './pages/PotentialCustomersPage';
import CouponsPage from './pages/CouponsPage';
import WooCommercePage from './pages/WooCommercePage';
import SettingsPage from './pages/SettingsPage';
import MediaPage from './pages/MediaPage';

// WhatsApp Pages
import WADashboardPage from './pages/whatsapp/WADashboardPage';
import WATemplatesPage from './pages/whatsapp/WATemplatesPage';
import WAGroupsPage, { WAGroupDetailPage } from './pages/whatsapp/WAGroupsPage';
import WACampaignsPage from './pages/whatsapp/WACampaignsPage';
import WACampaignWizard from './pages/whatsapp/WACampaignWizard';
import WASendQueuePage from './pages/whatsapp/WASendQueuePage';
import WAFixedFlowsPage from './pages/whatsapp/WAFixedFlowsPage';
import WAFixedFlowDetailPage from './pages/whatsapp/WAFixedFlowDetailPage';
import WAAnniversaryFlowsPage from './pages/whatsapp/WAAnniversaryFlowsPage';
import WAAnniversaryFlowDetailPage from './pages/whatsapp/WAAnniversaryFlowDetailPage';
import WAAnniversaryFlowCreatePage from './pages/whatsapp/WAAnniversaryFlowCreatePage';

// Layout
import MainLayout from './components/layout/MainLayout';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#4F46E5]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Public Route Component (redirects to dashboard if logged in)
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#4F46E5]"></div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      {/* Protected Routes */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/clients/:id" element={<ClientDetailPage />} />
        <Route path="/client-history" element={<ClientHistoryPage />} />
        <Route path="/follow-ups" element={<FollowUpsPage />} />
        <Route path="/potential-customers" element={<PotentialCustomersPage />} />
        <Route path="/coupons" element={<CouponsPage />} />
        <Route path="/woocommerce" element={<WooCommercePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/media" element={<MediaPage />} />
        
        {/* WhatsApp Broadcast Routes */}
        <Route path="/whatsapp" element={<WADashboardPage />} />
        <Route path="/whatsapp/templates" element={<WATemplatesPage />} />
        <Route path="/whatsapp/groups" element={<WAGroupsPage />} />
        <Route path="/whatsapp/groups/:groupId" element={<WAGroupDetailPage />} />
        <Route path="/whatsapp/campaigns" element={<WACampaignsPage />} />
        <Route path="/whatsapp/campaigns/new" element={<WACampaignWizard />} />
        <Route path="/whatsapp/campaigns/:campaignId/queue" element={<WASendQueuePage />} />
        <Route path="/whatsapp/fixed-flows" element={<WAFixedFlowsPage />} />
        <Route path="/whatsapp/fixed-flows/:flowId" element={<WAFixedFlowDetailPage />} />
        <Route path="/whatsapp/anniversary-flows" element={<WAAnniversaryFlowsPage />} />
        <Route path="/whatsapp/anniversary-flows/create" element={<WAAnniversaryFlowCreatePage />} />
        <Route path="/whatsapp/anniversary-flows/:flowId" element={<WAAnniversaryFlowDetailPage />} />
      </Route>

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
